import { UtilityServices } from "../../../core/services/UtilityServices";
import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import React, { useState } from "react";
import { Button } from "rsuite";
import { useTranslation } from "react-i18next";
import { encryptUrl } from "../../../navigation/useDecryptParams";
import { ContentRoutes } from "../../../navigation/NavConstant";
import { useNavigate } from "react-router-dom";
import { Trash } from "@rsuite/icons";

const MusicScheduleSongBulkAction = ({
  musicScheduleData,
  checkedKeys,
  setCheckedKeys,
  onDeleteSongs,
  enableBulkAction = ["delete", "add"],
  ...props
}: {
  musicScheduleData: any;
  checkedKeys: any;
  setCheckedKeys: Function;
  onDeleteSongs?: Function;
  enableBulkAction?: string[];
}) => {
  const { t } = useTranslation();
  const [openBulkActionNoSelectionModal, setOpenBulkActionNoSelectionModal] =
    useState(false);
  const [openBulkDeleteModal, setOpenBulkDeleteModal] = useState(false);
  const [bulkActionMessage, setBulkActionMessage] = useState("");
  const [bulkActionTitle, setBulkActionTitle] = useState("");
  const ecryptedMusicScheduleId = encryptUrl(`${musicScheduleData.id}`);

  const addSongsToMusicScheduleLink =
    ContentRoutes.ADD_SONGS_TO_MUSIC_SCHEDULE.replace(
      ":id",
      ecryptedMusicScheduleId.toString()
    );
  const navigate = useNavigate();

  function handleAddSongsToMusicScheduleAction() {
    navigate(`${addSongsToMusicScheduleLink}`);
  }

  function bulkDelete() {
    if (checkedKeys.length === 0) {
      setOpenBulkActionNoSelectionModal(true);
      return true;
    }
    setOpenBulkDeleteModal(true);

    setBulkActionMessage(
      t("CONFIRM_ACTION", {
        action: t("DELETE").toLowerCase(),
        entity: t("SONG").toLowerCase(),
      })
    );
    setBulkActionTitle(
      t("CONFIRM_ACTION_TITLE", {
        action: t("DELETE").toLowerCase(),
      })
    );
  }

  return (
    <div className="music-schedule-song-action">
      <div className="music-schedule-song-action-toolbar">
        <div className="music-schedule-song-action-title">Bulk Actions</div>
        <div className="music-schedule-song-action-buttons">
          {UtilityServices.hasPermission("delete-song") &&
            enableBulkAction.includes("delete") && (
              <Button
                className="music-schedule-song-bulk-btn music-schedule-song-bulk-btn-delete"
                appearance="ghost"
                onClick={bulkDelete}
                startIcon={<Trash />}
                title={t("DELETE") + " " + t("SONGS")}
              >
                {t("DELETE")} {t("SONGS")}
              </Button>
            )}

          {UtilityServices.hasPermission("delete-song") &&
            enableBulkAction.includes("add") && (
              <Button
                className="music-schedule-song-bulk-btn music-schedule-song-bulk-btn-add"
                appearance="ghost"
                onClick={handleAddSongsToMusicScheduleAction}
                startIcon={
                  <span className="music-schedule-song-plus-icon">+</span>
                }
                title={t("ADD") + " " + t("SONGS")}
              >
                {t("ADD")} {musicScheduleData.total_songs > 0 && t("MORE")}{" "}
                {t("SONGS")}
              </Button>
            )}
        </div>
      </div>
      <AlertModal
        open={openBulkActionNoSelectionModal}
        handleClose={(e: any) => {
          if (e) {
            setOpenBulkActionNoSelectionModal(false);
          }
        }}
        displayText={t("PLEASE_SELECT_RECORD_TO_ACTION")}
        modalTitle={t("PLEASE_SELECT")}
        cancelButton={false}
      />

      <AlertModal
        open={openBulkDeleteModal}
        handleClose={(e: any) => {
          if (e == true) {
            onDeleteSongs();
            setOpenBulkDeleteModal(false);
          } else {
            setOpenBulkDeleteModal(false);
          }
        }}
        displayText={bulkActionMessage}
        modalTitle={bulkActionTitle}
      />
    </div>
  );
};

export default MusicScheduleSongBulkAction;
